import getLocalString from "constants/Localization";
import { useGetReportJobDetailsMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportJobDetails = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportJobDetailsMutation();
  const [getReportJobDetails, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportJobDetails",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportJobDetails, { ...context, data }] as const;
};

export default useGetReportJobDetails;
